import { createGlobalStyle } from "styled-components";
import { MAIN_COLORS } from "../consts/colors";


export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: 'ComplianceSans';
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  button {
    outline: none;
    color: #000;
    cursor: pointer;
    font-family: 'ComplianceSans';
  }

  input {
    font-family: 'ComplianceSans';
  }

  body{
    height:100%;
    background: ${MAIN_COLORS.purple_100};
    color: #FFFFFA;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  html{
    background: ${MAIN_COLORS.purple_100};
    background-repeat: no-repeat;
    background-size: cover;
    display:block;
    touch-action: none;
    text-rendering: optimizeLegibility;
  }

  img {
    object-fit: contain; 
  }

  ::-webkit-scrollbar {
    width: 0.5px;
    opacity: 0;
    display: none;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.6);
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;